export default {
    inject: ['ENV'],
    data() {
        return {
            anjuke: 'https://pages.anjukestatic.com/usersite/pc/ajk/anjuke-icon@2x.png',
            wuba: 'http://img.58cdn.com.cn/logo/58/252_84/logo-o.png?v=2'
        };
    }
};
